<div class="wrapper">
    <app-enterprise-navigation></app-enterprise-navigation>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <app-enterprise-header title="Dashboard"></app-enterprise-header>
        <section class="content mb-4">
            <div class="d-flex align-items-baseline">
                <div class="sales-dashboard">
                    <app-sales-dashboard></app-sales-dashboard>
                </div>
            </div>
        </section>
    </div>
    <div class="control-sidebar-bg"></div>
</div>
